// TODO: some of this is duplicated in the training-profile-engine app,
// could move to a shared location

import type { AllowedPartners, AllowedTenants, LineOfBusiness, TemplateBase } from "@expert/expert-university";

import { useQuery } from "@tanstack/react-query";

import { getSharedApiClient } from "@/shared-utils";

const getTemplatesByPartner = async (
    tenant: AllowedTenants,
    partner: AllowedPartners,
    correlationId: string,
    _lob?: LineOfBusiness,
): Promise<TemplateBase[]> => {
    const response = await getSharedApiClient().get(`api/expert-university/v1/templates/${tenant}/${partner}`, {
        headers: {
            "x-ewp-correlation-id": correlationId,
        },
    });

    const templates = await response.json<TemplateBase[]>();

    return templates.filter((template) => template.lob === "soluto");
};

export const getProfileById = async (templateId: string, correlationId?: string): Promise<TemplateBase> => {
    const response = await getSharedApiClient().get(`api/expert-university/v1/template/asurion/${templateId}`, {
        headers: {
            "x-ewp-correlation-id": correlationId,
        },
    });

    return response.json<TemplateBase>();
};

export const useTrainingProfiles = (
    tenant: AllowedTenants,
    partner: AllowedPartners,
    correlationId: string,
    lob?: LineOfBusiness,
) => {
    const { data } = useQuery({
        queryKey: ["training-profiles", partner],
        queryFn: () => getTemplatesByPartner(tenant, partner, correlationId, lob),
    });

    return data;
};
